import RateFilter from './RateFilter.vue'

export default RateFilter
